import Icon from '../ui/Icon';
import StatusBadge from '../ui/StatusBadge';

const TH = 'py-3 px-4 text-left text-[11px] leading-[14px] font-semibold text-on-surface-variant uppercase tracking-wider whitespace-nowrap';

/** One row per scan; the row (and its ref link) opens the review page. */
export default function ScansTable({ rows, refreshing, onOpen }) {
  return (
    <div className="w-full overflow-x-auto" aria-busy={refreshing}>
      <table className="w-full min-w-[960px] text-left border-collapse">
        <caption className="sr-only">Receipt scans</caption>
        <thead>
          <tr className="bg-surface-container-low border-b border-surface-container">
            <th scope="col" className={TH}>
              Scan Ref
            </th>
            <th scope="col" className={TH}>
              Date &amp; Time
            </th>
            <th scope="col" className={TH}>
              Station &amp; Location
            </th>
            <th scope="col" className={TH}>
              Product
            </th>
            <th scope="col" className={`${TH} text-right`}>
              Extracted Price
            </th>
            <th scope="col" className={TH}>
              User
            </th>
            <th scope="col" className={`${TH} text-right`}>
              Status
            </th>
          </tr>
        </thead>
        <tbody className={`divide-y divide-surface-container transition-opacity ${refreshing ? 'opacity-50' : ''}`}>
          {rows.map((row) => (
            <tr key={row.id} onClick={() => onOpen(row.id)} className="cursor-pointer hover:bg-surface-container-low/60 transition-colors">
              <th scope="row" className="py-3.5 px-4 font-normal">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpen(row.id);
                  }}
                  aria-label={`Open scan ${row.ref}`}
                  className="font-data-mono text-[13px] font-bold text-primary hover:underline rounded outline-none focus-visible:ring-2 focus-visible:ring-status-ok-dot"
                >
                  {row.ref}
                </button>
              </th>
              <td className="py-3.5 px-4 text-[13px] text-on-surface-variant whitespace-nowrap">{row.date}</td>
              <td className="py-3.5 px-4">
                <div className="flex items-center gap-1.5 min-w-[220px]">
                  <span
                    className={`text-[13px] text-on-surface truncate max-w-[300px] ${row.station.isPlaceId ? 'font-data-mono text-xs' : ''} ${row.station.fromReceipt ? 'italic' : ''}`}
                    title={row.station.fromReceipt ? 'Name read from the receipt' : undefined}
                  >
                    {row.station.name}
                    {row.station.city && <span className="text-on-surface-variant"> ({row.station.city})</span>}
                  </span>
                  {row.warnings.map((w) => (
                    <span key={w} title={w} className="inline-flex text-status-pending-text shrink-0">
                      <Icon name="warning" size={16} />
                      <span className="sr-only">{w}</span>
                    </span>
                  ))}
                </div>
              </td>
              <td className="py-3.5 px-4 text-[13px] text-on-surface whitespace-nowrap">{row.product}</td>
              <td className="py-3.5 px-4 text-right font-data-mono text-[13px] font-bold text-on-surface whitespace-nowrap">{row.price}</td>
              <td className="py-3.5 px-4">
                <p className="text-xs text-on-surface truncate max-w-[160px]">{row.user.name}</p>
                {row.user.userId && <p className="font-data-mono text-[11px] text-on-surface-variant">{row.user.userId}</p>}
              </td>
              <td className="py-3.5 px-4 text-right">
                <StatusBadge tone={row.status.tone}>{row.status.label}</StatusBadge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
